import angular from 'angular'
import './blockchain.service'

angular
  .module('admin.blockchain', ['admin.blockchain.service'])
  .controller('BlockchainCtrl', BlockchainCtrl)

/** @ngInject */
function BlockchainCtrl($q, BlockchainService, UploadService, EventService) {
  var vm = this
  vm.itemsBlockchains = []
  vm.itemsSmartContracts = []
  vm.itemsSmartContractDeployments = []
  vm.itemsSmartContractFeatures = []
  vm.perPage = 25

  vm.scfTypes = [
    {
      id: 1,
      name: 'Mint',
    },
    {
      id: 2,
      name: 'Unmint',
    },
    {
      id: 3,
      name: 'Burn',
    },
    {
      id: 4,
      name: 'EIP2981',
    },
    {
      id: 5,
      name: 'Mint with Escrow',
    },
    {
      id: 6,
      name: 'ERC721 Base Features',
    },
  ]

  vm.selectedTab = 'blockchain'

  function reloadPaginationBlockchain() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationSmartContracts() {
    vm.totalItems2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationSmartContractDeployments() {
    vm.totalItems3 = 0
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  function reloadPaginationSmartContractFeatures() {
    vm.totalItems4 = 0
    vm.oldPage4 = 0
    vm.currentPage4 = 25
    vm.first4 = true
    vm.totalItems4 = 0
    vm.pagination4 = {
      current: 1,
    }
  }

  reloadPaginationBlockchain()
  reloadPaginationSmartContracts()
  reloadPaginationSmartContractDeployments()
  reloadPaginationSmartContractFeatures()

  var tab = localStorage.getItem('blockchain_tab')
  if (tab !== null) {
    if (tab === 'blockchain') {
      $('#blockchain').addClass('active')
      $('#blockchain_tab').addClass('active')
      $('#smart_contract').removeClass('active')
      $('#smart_contract_tab').removeClass('active')
      $('#smart_contract_deployment').removeClass('active')
      $('#smart_contract_deployment_tab').removeClass('active')
      $('#smart_contract_features').removeClass('active')
      $('#smart_contract_features_tab').removeClass('active')
      $('#smart_contract_deployment_collectible').removeClass('active')
      $('#smart_contract_deployment_collectible_tab').removeClass('active')
    } else if (tab === 'smart_contract') {
      $('#blockchain').removeClass('active')
      $('#blockchain_tab').removeClass('active')
      $('#smart_contract').addClass('active')
      $('#smart_contract_tab').addClass('active')
      $('#smart_contract_deployment').removeClass('active')
      $('#smart_contract_deployment_tab').removeClass('active')
      $('#smart_contract_features').removeClass('active')
      $('#smart_contract_features_tab').removeClass('active')
      $('#smart_contract_deployment_collectible').removeClass('active')
      $('#smart_contract_deployment_collectible_tab').removeClass('active')
    } else if (tab === 'smart_contract_deployment') {
      $('#blockchain').removeClass('active')
      $('#blockchain_tab').removeClass('active')
      $('#smart_contract').removeClass('active')
      $('#smart_contract_tab').removeClass('active')
      $('#smart_contract_deployment').addClass('active')
      $('#smart_contract_deployment_tab').addClass('active')
      $('#smart_contract_features').removeClass('active')
      $('#smart_contract_features_tab').removeClass('active')
      $('#smart_contract_deployment_collectible').removeClass('active')
      $('#smart_contract_deployment_collectible_tab').removeClass('active')
    } else if (tab === 'smart_contract_features') {
      $('#blockchain').removeClass('active')
      $('#blockchain_tab').removeClass('active')
      $('#smart_contract').removeClass('active')
      $('#smart_contract_tab').removeClass('active')
      $('#smart_contract_deployment').removeClass('active')
      $('#smart_contract_deployment_tab').removeClass('active')
      $('#smart_contract_features').addClass('active')
      $('#smart_contract_features_tab').addClass('active')
      $('#smart_contract_deployment_collectible').removeClass('active')
      $('#smart_contract_deployment_collectible_tab').removeClass('active')
    } else {
      $('#blockchain').removeClass('active')
      $('#blockchain_tab').removeClass('active')
      $('#smart_contract').removeClass('active')
      $('#smart_contract_tab').removeClass('active')
      $('#smart_contract_deployment').removeClass('active')
      $('#smart_contract_deployment_tab').removeClass('active')
      $('#smart_contract_features').removeClass('active')
      $('#smart_contract_features_tab').removeClass('active')
      $('#smart_contract_deployment_collectible').addClass('active')
      $('#smart_contract_deployment_collectible_tab').addClass('active')
    }
  } else {
    $('#blockchain').addClass('active')
    $('#blockchain_tab').addClass('active')
    $('#smart_contract').removeClass('active')
    $('#smart_contract_tab').removeClass('active')
    $('#smart_contract_deployment').removeClass('active')
    $('#smart_contract_deployment_tab').removeClass('active')
    $('#smart_contract_features').removeClass('active')
    $('#smart_contract_features_tab').removeClass('active')
    $('#smart_contract_deployment_collectible').removeClass('active')
    $('#smart_contract_deployment_collectible_tab').removeClass('active')
  }

  vm.tabBlockchain = function () {
    $('#blockchain').addClass('active')
    $('#smart_contract').removeClass('active')
    $('#smart_contract_deployment').removeClass('active')
    $('#smart_contract_features').removeClass('active')
    $('#smart_contract_deployment_collectible').removeClass('active')
    vm.selectedTab = 'blockchain'
    localStorage.setItem('blockchain_tab', 'blockchain')
  }

  vm.tabSmartContract = function () {
    $('#blockchain').removeClass('active')
    $('#smart_contract').addClass('active')
    $('#smart_contract_deployment').removeClass('active')
    $('#smart_contract_features').removeClass('active')
    $('#smart_contract_deployment_collectible').removeClass('active')
    vm.selectedTab = 'smart_contract'
    localStorage.setItem('smart_contract_tab', 'smart_contract')
  }

  vm.tabSmartContractDeployment = function () {
    $('#blockchain').removeClass('active')
    $('#smart_contract').removeClass('active')
    $('#smart_contract_deployment').addClass('active')
    $('#smart_contract_deployment_collectible').removeClass('active')
    $('#smart_contract_features').removeClass('active')
    vm.selectedTab = 'smart_contract_deployment'
    localStorage.setItem('smart_contract_deployment_tab', 'smart_contract_deployment')
  }

  vm.tabSmartContractFeatures = function () {
    $('#blockchain').removeClass('active')
    $('#smart_contract').removeClass('active')
    $('#smart_contract_deployment').removeClass('active')
    $('#smart_contract_deployment_collectible').removeClass('active')
    $('#smart_contract_features').addClass('active')
    vm.selectedTab = 'smart_contract_features'
    localStorage.setItem('smart_contract_features_tab', 'smart_contract_features')
  }

  vm.tabSmartContractDeploymentCollectible = function () {
    $('#blockchain').removeClass('active')
    $('#smart_contract').removeClass('active')
    $('#smart_contract_deployment').removeClass('active')
    $('#smart_contract_features').removeClass('active')
    $('#smart_contract_deployment_collectible').addClass('active')
    vm.selectedTab = 'smart_contract_deployment_collectible'
    localStorage.setItem('smart_contract_features_tab', 'smart_contract_deployment_collectible')
  }

  function reloadBlockchains() {
    BlockchainService.listBlockchains(0, 50).then(function (result) {
      vm.allBlockchains = result.results
    })

    BlockchainService.listSmartContracts(0, 50).then(function (result) {
      vm.allSmartContracts = result.results
    })
  }

  reloadBlockchains()

  function loadBlockchain(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    BlockchainService.listBlockchains(vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.itemsBlockchains = result.results
    })
  }

  function loadSmartContracts(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    BlockchainService.listSmartContracts(vm.oldPage2, 25).then(function (result) {
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.itemsSmartContracts = result.results
    })
  }

  function loadSmartContractDeployments(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first3) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }

    BlockchainService.listSmartContractDeployments(vm.oldPage3, 25).then(function (result) {
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.itemsSmartContractDeployments = result.results
    })
  }

  function loadSmartContractFeatures(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination4.current = 1
    }
    if (!vm.first4) {
      vm.currentPage4 = pageNumber * 25
      vm.oldPage4 = vm.currentPage4 - 25
    } else {
      vm.first4 = false
    }

    BlockchainService.listSmartContractFeatures(vm.oldPage4, 25).then(function (result) {
      if (vm.totalItems4 === 0) {
        vm.totalItems4 = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        switch (result.results[i].k) {
          case 1:
            result.results[i].type = 'Mint'
            break
          case 2:
            result.results[i].type = 'Unmint'
            break
          case 3:
            result.results[i].type = 'Burn'
            break
          case 4:
            result.results[i].type = 'EIP2981'
            break
          case 5:
            result.results[i].type = 'Mint with Escrow'
            break
          case 6:
            result.results[i].type = 'ERC721 Base Features'
            break
        }
      }

      vm.itemsSmartContractFeatures = result.results
    })
  }

  loadBlockchain(1)
  loadSmartContracts(1)
  loadSmartContractDeployments(1)
  loadSmartContractFeatures(1)

  vm.loadBlockchain = function () {
    reloadPaginationBlockchain()
    loadBlockchain(1)
  }

  vm.loadSmartContracts = function () {
    reloadPaginationSmartContracts()
    loadSmartContracts(1)
  }

  vm.loadSmartContractDeployments = function () {
    reloadPaginationSmartContractDeployments()
    loadSmartContractDeployments(1)
  }

  vm.loadSmartContractFeatures = function () {
    reloadPaginationSmartContractFeatures()
    loadSmartContractFeatures(1)
  }

  vm.pageChangedBlockchain = function (newPage) {
    loadBlockchain(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChangedSmartContracts = function (newPage) {
    loadSmartContracts(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChangedSmartContractDeployments = function (newPage) {
    loadSmartContractDeployments(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChangedSmartContractFeatures = function (newPage) {
    loadSmartContractFeatures(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.addBlockchain = function () {
    vm.blockchain = {
      id: 0,
      n: 0,
      'img-i': '',
      'id-chain': '',
      sym: '',
      t: '',
      'url-explore': '',
      'url-rpc': '',
    }
    $('#myModalAddBlockchain').modal('show')
  }

  vm.editBlockchain = function (item) {
    vm.blockchain = angular.copy(item)
    delete vm.blockchain.ts
    delete vm.blockchain['ts-m']
    $('#myModalAddBlockchain').modal('show')
  }

  vm.createBlockchain = function () {
    if (!vm.blockchain['id-chain']) {
      swal('Please enter an ID Chain', '', 'error')
      return
    }
    if (!vm.blockchain.sym) {
      swal('Please enter a Symbol', '', 'error')
      return
    }
    if (!vm.blockchain.t) {
      swal('Please enter a Network', '', 'error')
      return
    }
    if (!vm.blockchain['url-explore']) {
      swal('Please enter a Url Explore', '', 'error')
      return
    }
    if (!vm.blockchain['url-rpc']) {
      swal('Please enter a Url RPC', '', 'error')
      return
    }
    BlockchainService.saveBlockchain(vm.blockchain).then(
      function () {
        $('#myModalAddBlockchain').modal('hide')
        loadBlockchain(1)
        reloadBlockchains()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.updateBlockchain = function () {
    if (!vm.blockchain['id-chain']) {
      swal('Please enter an ID Chain', '', 'error')
      return
    }
    if (!vm.blockchain.sym) {
      swal('Please enter a Symbol', '', 'error')
      return
    }
    if (!vm.blockchain.t) {
      swal('Please enter a Title', '', 'error')
      return
    }
    if (!vm.blockchain['url-explore']) {
      swal('Please enter a Url Explore', '', 'error')
      return
    }
    if (!vm.blockchain['url-rpc']) {
      swal('Please enter a Url RPC', '', 'error')
      return
    }

    BlockchainService.updateBlockchain(vm.blockchain.id, vm.blockchain).then(
      function () {
        $('#myModalAddBlockchain').modal('hide')
        loadBlockchain(1)
        reloadBlockchains()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteBlockchain = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          BlockchainService.removeBlockchain(item.id).then(
            function () {
              $('#myModalAddBlockchain').modal('hide')
              loadBlockchain(1)
              reloadBlockchains()
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.addSmartContract = function () {
    vm.smartContract = {
      id: 0,
      t: '',
      txt: '',
      'url-src': '',
    }
    $('#myModalSmartContract').modal('show')
  }

  vm.editSmartContract = function (item) {
    vm.smartContract = angular.copy(item)
    delete vm.smartContract.ts
    delete vm.smartContract['ts-m']
    $('#myModalSmartContract').modal('show')
  }

  vm.createSmartContract = function () {
    if (!vm.smartContract['t']) {
      swal('Please enter a Name', '', 'error')
      return
    }
    if (!vm.smartContract['url-src']) {
      swal('Please enter a Source URL', '', 'error')
      return
    }

    BlockchainService.saveSmartContracts(vm.smartContract).then(
      function () {
        $('#myModalSmartContract').modal('hide')
        loadSmartContracts(1)
        reloadBlockchains()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.updateSmartContract = function () {
    BlockchainService.updateSmartContracts(vm.smartContract.id, vm.smartContract).then(
      function () {
        $('#myModalSmartContract').modal('hide')
        loadSmartContracts(1)
        reloadBlockchains()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteSmartContract = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          BlockchainService.removeSmartContracts(item.id).then(
            function () {
              $('#myModalSmartContract').modal('hide')
              loadSmartContracts(1)
              reloadBlockchains()
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.addSmartContractDeployment = function () {
    vm.smartContractDeployment = {
      id: 0,
      t: '',
      txt: '',
      sym: '',
      addr: '',
      'id-block': '',
      'id-sc': '',
    }
    $('#myModalSmartContractDeployment').modal('show')
  }

  vm.editSmartContractDeployment = function (item) {
    vm.smartContractDeployment = angular.copy(item)
    delete vm.smartContractDeployment.ts
    delete vm.smartContractDeployment['ts-m']
    $('#myModalSmartContractDeployment').modal('show')
  }

  vm.createSmartContractDeployment = function () {
    if (!vm.smartContractDeployment['t']) {
      swal('Please enter an Title', '', 'error')
      return
    }
    if (!vm.smartContractDeployment['sym']) {
      swal('Please enter an Symbol', '', 'error')
      return
    }
    if (!vm.smartContractDeployment['addr']) {
      swal('Please enter an Address', '', 'error')
      return
    }
    if (!vm.smartContractDeployment['id-block']) {
      swal('Please enter a Blockchain', '', 'error')
      return
    }
    if (!vm.smartContractDeployment['id-sc']) {
      swal('Please enter a Smart Contract', '', 'error')
      return
    }

    BlockchainService.saveSmartContractDeployments(vm.smartContractDeployment).then(
      function () {
        $('#myModalSmartContractDeployment').modal('hide')
        loadSmartContractDeployments(1)
        reloadBlockchains()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.updateSmartContractDeployment = function () {
    BlockchainService.updateSmartContractDeployments(
      vm.smartContractDeployment.id,
      vm.smartContractDeployment,
    ).then(
      function () {
        $('#myModalSmartContractDeployment').modal('hide')
        loadSmartContractDeployments(1)
        reloadBlockchains()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteSmartContractDeployment = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          BlockchainService.removeSmartContractDeployments(item.id).then(
            function () {
              $('#myModalSmartContractDeployment').modal('hide')
              loadSmartContractDeployments(1)
              reloadBlockchains()
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.addSmartContractFeatures = function () {
    vm.smartContractFeatures = {
      id: 0,
      t: '',
      name: '',
      txt: '',
      k: 0,
    }
    $('#myModalSmartContractFeatures').modal('show')
  }

  vm.editSmartContractFeatures = function (item) {
    vm.smartContractFeatures = angular.copy(item)
    $('#myModalSmartContractFeatures').modal('show')
  }

  vm.createSmartContractFeatures = function () {
    if (!vm.smartContractFeatures.t) {
      swal('Please enter a Title', '', 'error')
      return
    }
    if (!vm.smartContractFeatures.name) {
      swal('Please enter a Name', '', 'error')
      return
    }
    if (!vm.smartContractFeatures.k) {
      swal('Please enter a Type', '', 'error')
      return
    }

    BlockchainService.saveSmartContractFeatures(vm.smartContractFeatures).then(
      function () {
        $('#myModalSmartContractFeatures').modal('hide')
        loadSmartContractFeatures(1)
        reloadBlockchains()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.updateSmartContractFeatures = function () {
    BlockchainService.updateSmartContractFeatures(
      vm.smartContractFeatures.id,
      vm.smartContractFeatures,
    ).then(
      function () {
        $('#myModalSmartContractFeatures').modal('hide')
        loadSmartContractFeatures(1)
        reloadBlockchains()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteSmartContractFeatures = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          BlockchainService.removeSmartContractFeatures(item.id).then(
            function () {
              $('#myModalSmartContractFeatures').modal('hide')
              loadSmartContractFeatures(1)
              reloadBlockchains()
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.loadBlockchainImage = false
  vm.uploadBlockchain = function (item) {
    vm.loadBlockchainImage = true
    UploadService.save('blockchains', vm.pathImgBlockchain, 'image', item.id).then(
      function (fileName) {
        vm.loadBlockchainImage = false
        item['img-i'] = fileName
      },
    )
  }

  vm.pendingTx = function (item) {
    window.open('https://etherscan.io/txsPending?a=' + item.addr + '&m=hf', '_blank')
  }

  EventService.listChannels().then(function (result) {
    vm.channels = result.results
  })

  BlockchainService.listSmartContractDeployments(0, 500).then(function (result) {
    vm.allSmartContractDeployments = result.results
  })

  $('#setSelect').select2('data', null)
  vm.searchCollectibles = function () {
    let channelId = vm.channelId
    let setId = parseInt($('#setSelect').select2('val'))

    BlockchainService.listCollectibles(channelId, setId).then(function (result) {
      let collectibles = result.results
      for (let i = 0; i < collectibles.length; i++) {
        let scds = ``
        for (let j = 0; j < collectibles[i].scd.length; j++) {
          scds += `${collectibles[i].scd[j].t}, `
        }
        collectibles[i].scd_t = scds.substring(0, scds.length - 2)
      }
      vm.collectibles = result.results
    })
  }

  vm.saveCollectibleSmartContract = function () {
    let channelId = vm.channelId
    let setId = parseInt($('#setSelect').select2('val'))

    if (!channelId && !setId) {
      swal('Please select a Channel or a Set', '', 'error')
      return
    }

    if (channelId && !setId) {
      BlockchainService.saveCollectibleSmartContract(vm.scdId, {
        'id-ch': channelId,
      }).then(
        function () {
          swal('Collectibles saved successfully', '', 'success')
          vm.searchCollectibles()
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
      return
    }

    if (setId) {
      BlockchainService.saveCollectibleSmartContract(vm.scdId, {
        'id-s': setId,
      }).then(
        function () {
          swal('Collectibles saved successfully', '', 'success')
          vm.searchCollectibles()
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
      return
    }

    let collectibleIds = []
    for (let i = 0; i < vm.collectibles.length; i++) {
      collectibleIds.push(vm.collectibles[i].id)
    }

    BlockchainService.saveCollectibleSmartContract(vm.scdId, {
      collectibles: collectibleIds,
    }).then(
      function () {
        swal('Collectibles saved successfully', '', 'success')
        vm.searchCollectibles()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteAllCollectibleSmartContract = function () {
    let channelId = vm.channelId
    let setId = parseInt($('#setSelect').select2('val'))

    if (!channelId && !setId) {
      swal('Please select a Channel or a Set', '', 'error')
      return
    }

    let collectibleIds = []
    for (let i = 0; i < vm.collectibles.length; i++) {
      collectibleIds.push(vm.collectibles[i].id)
    }

    BlockchainService.deleteMultipleCollectibleSmartContract(vm.scdId, {
      collectibles: collectibleIds,
    }).then(
      function () {
        swal('Collectibles saved successfully', '', 'success')
        vm.searchCollectibles()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteOneCollectibleSmartContract = function (item) {
    let promise = []
    item.scd.forEach((scd) => {
      promise.push(BlockchainService.deleteCollectibleSmartContract(scd.id, item.id))
    })
    $q.all(promise).then(
      function () {
        swal('Collectible deleted successfully', '', 'success')
        vm.searchCollectibles()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }
}
